module.exports = __webpack_public_path__ + "static/media/lipakshi.52ca2543.jpeg";